import { Injectable } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';


@Injectable()
export class SearchService {
    protected searchSubject = new Subject<string>();

    constructor() {
    }

    get keyword$(): Observable<string> {
        return this.searchSubject
    }

    emitKeyword(keyword: string) {
        this.searchSubject.next(keyword)
    }
}